import PaymentDetailsBlock from '@anm/components/subscription/payment-details/PaymentDetailsBlock';
import { FC } from 'react';
import { useSelector } from 'react-redux';

import SuccessEditCreditCardAlert from '../../../components/pricing/alerts/SuccessEditCreditCardAlert';
import vtConfig from '../../../config';
import mapCardType from '../../../helpers/user/mapCardType';
import useUserCard from '../../../hooks/user/useUserCard';
import { subscriptionSelectors } from '../../../store/modules/subscription';
import EditCreditCard from '../../pricing/EditCreditCard';

import Notifications from './Notifications';
import { useDeleteCard, useEditCardModalControls } from './hooks';

export type UserPaymentDetailsProps = {};

const { ssl } = vtConfig();

const UserPaymentDetails: FC<UserPaymentDetailsProps> = () => {
  const card = useUserCard();
  const isDeletePending = useSelector(subscriptionSelectors.selectDeleteCardIsPending);
  const { last4, type } = card || {};
  const [isEditCreditCardOpen, openEditCreditCard, closeEditCreditCard] = useEditCardModalControls();
  const handleDeleteCard = useDeleteCard();

  return (
    <>
      {isEditCreditCardOpen && (
        <EditCreditCard onModalClose={closeEditCreditCard}>{!!type ? 'Change Card' : 'Add Card'}</EditCreditCard>
      )}
      <SuccessEditCreditCardAlert action={!!type ? 'changed' : 'added'} />
      <Notifications />
      <PaymentDetailsBlock
        sslId={ssl}
        last4={last4}
        cardType={type && mapCardType(type)}
        isDeletePending={isDeletePending}
        onClick={openEditCreditCard}
        onDelete={handleDeleteCard}
      />
    </>
  );
};
export default UserPaymentDetails;
